<template>
    <div :class="sideNavInactive ? 'side-nav--inactive' : ''" class="side-nav">
        <div class="side-nav__search-area">
            <slot name="search-area"></slot>
        </div>
        <div class="side-nav__item-list">
            <SideNavItem
                v-for="item in items"
                :key="item.id"
                :attribute="item.attribute"
                :category="item.category"
                :selected="selected === item.id"
                :sub-category="item.subCategory"
                :title="item.title"
                @click="selected = item.id"
            >
            </SideNavItem>
        </div>
    </div>
</template>

<script>
import SideNavItem from "./reusable/SideNavItem.vue";
import {mapActions} from "vuex";

export default {
    name: 'SideNav',
    components: {SideNavItem},
    props: {
        sideNavInactive: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        selected: {
            get() {
                return this.$store.state.sideNav.selected
            },
            set(value) {
                this.setSelected(value)
                const item = this.$store.state.sideNav.items.find(item => item.id === value)
                if (item) {
                    this.$router.push(item.url)
                }
            }
        },
        items: {
            get() {
                return this.$store.state.sideNav.items
            },
            set(value) {
                this.setItems(value)
            }
        }
    },
    created() {
        this.items = this.$store.state.sideNav.items
    },
    methods: {
        ...mapActions({
            setSelected: "sideNav/selectItem",
            setItems: "sideNav/setItems"
        })
    }
};
</script>
